import { useEffect, useRef } from "react";
import type { AgentSeat } from "./api";
import { HEAD_URL, HOST, Stage, agentColor, agentLook, hostFace, setSamplers } from "./heads";

// An AI participant: its talking head, rendered here. Never a video feed.
export function AgentTile({ seat, stage, speaking }: { seat: AgentSeat; stage: Stage; speaking: boolean }) {
	const frame = useRef<HTMLIFrameElement>(null);
	useEffect(() => {
		let morph: ReturnType<typeof setInterval> | undefined;
		const onMessage = (e: MessageEvent) => {
			const head = frame.current?.contentWindow;
			if (!head || e.source !== head || e.data?.type !== "pioneer-head-ready") return;
			setSamplers(e.data);
			const face = (morph: number) =>
				head.postMessage({ type: "pioneer-head-identity", ...(seat.slug === HOST ? hostFace() : agentLook(seat.slug)), morph, steady: morph > 0 }, "*");
			head.postMessage({ type: "pioneer-head-active", value: true }, "*");
			face(0);
			if (seat.slug === HOST && !matchMedia("(prefers-reduced-motion: reduce)").matches) morph = setInterval(() => face(2), 2000);
			stage.heads.set(seat.slug, head);
		};
		addEventListener("message", onMessage);
		return () => {
			removeEventListener("message", onMessage);
			clearInterval(morph);
			stage.heads.delete(seat.slug);
		};
	}, [seat.slug, stage]);
	return (
		<div
			className={`person-tile agent-tile ${speaking ? "speaking" : ""}`}
			data-speaker={seat.slug}
			style={{ "--agent": agentColor(seat.slug) } as React.CSSProperties}
		>
			<iframe ref={frame} src={HEAD_URL} title={seat.name} allow="autoplay" />
			<div className="person-label">
				<span className="agent-dot" />
				{seat.name} · AI
			</div>
		</div>
	);
}
